<template>
	<div class="look-history">
		<div class="right-title">浏览历史</div>
		<ul class="look-list">
			<li class="list-item" v-for="(item,idx) in list" @click="routeToHotelTemp(item)" v-show="idx<4">
				<div class="item-img history-img">
					<ImgLoader :imgUrl="item.Pics[0].Url|replaceImgSrc(4)"  v-if="item.Pics.length>0"/>
					<img src="./../../../assets/img/defaultHotel.jpg"  v-else >
				</div>
				<div class="item-content history-info">
					<p class="hotel-name">{{item.HotelName}}</p>
					<p class="time">{{item.date|dateClock}}</p>
				</div>
			</li>

		</ul>
	</div>
	
</template>
<script>
	import ImgLoader from './../imgLoader/imgLoader.vue'//图片异步加载+效果
	export default{
		name:"history",
		components:{
			ImgLoader
		},
		data(){
			return{
				list:this.dao.get('hotelHistory')||[]
			}
		},
		methods:{
            //打开详情
            routeToHotelTemp(item){

                var obj={
                	CityName:this.dao.get('hotelListSearchParams').CityName,
                    HotelID:item.ID,
                    From:item.From,
                    CheckIn:this.getDate(0),
                    CheckOut:this.getDate(1),
                    RoomCount:1,
                    AdultCount:2,
                    ChildrenAges:[],
                    ChildrenCount:0,
                    MyLat:'',
                    MyLon:'',
                    MyCityRegionID:'',
                }
                this.dao.set('hotelTempInfo',obj);
                this.$router.push('/HotelTemp?from='+this.$route.name);
            },
		}
	}
</script>


// WEBPACK FOOTER //
// src/common/cmpnt/History/History.vue